import React from 'react';
import NavBar from '../components/NavBar'
import Hero from '../components/Hero'
import Cta from '../components/Cta'
import Footer from '../components/Footer'
import ReactGA from "react-ga";
import { Helmet } from "react-helmet-async";

ReactGA.pageview(window.location.pathname + window.location.search);

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>SAWA | Studio of African Wildlife Art</title>
        <meta name="description" content="" />
        <link rel="canonical" href="/" />
      </Helmet>
      <NavBar />
      <Hero />
      <Cta />
      <Footer />
    </div>
  );
};

export default Home;
